var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimelineBannerIcRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1542_4694)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.50131 0.0654297C1.15655 0.0654297 0.0664062 1.15557 0.0664062 2.50033V17.4986C0.0664062 18.8433 1.15655 19.9336 2.50131 19.9336H17.4996C18.8443 19.9336 19.9344 18.8433 19.9344 17.4986V2.50033C19.9344 1.15557 18.8443 0.0654297 17.4996 0.0654297H2.50131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.50131 0.0654297C1.15655 0.0654297 0.0664062 1.15557 0.0664062 2.50033V4.99942H19.9344V2.50033C19.9344 1.15557 18.8443 0.0654297 17.4996 0.0654297H2.50131Z",
    fill: "#F7566C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09212 7.90039C8.78259 7.90039 8.53166 8.15131 8.53166 8.46085V10.6898H6.30264C5.99312 10.6898 5.74219 10.9407 5.74219 11.2502V13.0717C5.74219 13.3813 5.99312 13.6322 6.30264 13.6322H8.53159V15.8612C8.53159 16.1707 8.78252 16.4216 9.09204 16.4216H10.9135C11.2231 16.4216 11.474 16.1707 11.474 15.8612L11.4741 13.6322H13.703C14.0125 13.6322 14.2635 13.3813 14.2635 13.0717V11.2502C14.2635 10.9407 14.0125 10.6898 13.703 10.6898H11.4741V8.46085C11.4741 8.15131 11.2231 7.90039 10.9136 7.90039H9.09212Z",
    fill: "#F7566C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1542_4694"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineBannerIcRed);
export default __webpack_public_path__ + "static/media/timeline-banner-ic-red.c685cabaaf27c7d1e63de3c0bf7a14a4.svg";
export { ForwardRef as ReactComponent };